export const phoneNumbers = [
    '01234567890',
    '01234567890',

]

export const whatsappNumbers = [
    '01234567890'
]